import { SVGProps } from 'react';
const ToastSuccess = ({ fill = '#fff', ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M8.742 0a8.743 8.743 0 1 1 0 17.486A8.743 8.743 0 0 1 8.742 0Zm4.045 4.737L7.08 10.1l-2.383-2.24a1.39 1.39 0 0 0-1.88 0 1.196 1.196 0 0 0 0 1.767l3.324 3.122c.259.245.6.366.94.366.34 0 .68-.121.94-.366l6.646-6.245c.52-.487.52-1.278 0-1.766a1.39 1.39 0 0 0-1.88 0Z"
    />
  </svg>
);
export default ToastSuccess;
